import { render, staticRenderFns } from "./MemberRights.vue?vue&type=template&id=0e6063ff&scoped=true"
import script from "./MemberRights.vue?vue&type=script&lang=js"
export * from "./MemberRights.vue?vue&type=script&lang=js"
import style0 from "./MemberRights.vue?vue&type=style&index=0&id=0e6063ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6063ff",
  null
  
)

export default component.exports